import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { getDataOnRequest } from "../redux/actions/CommonActions";
import { getCurrentWeekDetails } from "../services/GlobalCurrentDateAndTime";
const AvaibilityContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const { userAuth, avaibility } = props;
    const dispatch = useDispatch();
    const { startDate } = getCurrentWeekDetails();
    useEffect(() => {
      if (userAuth.users_access_token && Object.keys(avaibility).length === 0)
        dispatch(
          getDataOnRequest(
            userAuth.users_access_token + (startDate ? "/" + startDate : ""),
            "GetAvaibilityStatus",
            "SET_AVAIBILITY"
          )
        );
   }, [userAuth.users_access_token, avaibility, startDate, dispatch]);

    return <OriginalComponent {...props} />;
  };
  return NewComponent;
};

const mapStateToProps = (state) => {
  return {
    userAuth: state.auth.authUserData,
    avaibility: state.avaibility.avaibility,
  };
};

const composedAvaibilityContainer = compose(
  connect(mapStateToProps),
  AvaibilityContainer
);
export default composedAvaibilityContainer;
